/* Various objects dealing with metrics... */

export enum Metric {
    Orders = 'Orders',
    Purchases = 'Purchases', // for backwards compatibiity, and maybe shopify
    Revenue = 'Revenue',
    Adspend = 'Adspend',
    ROAS = 'ROAS',
    CPP = 'CPP',
    AOV = 'AOV',
    MER = 'MER'
}